import AddOrEditAccountAddressContainer from './AddOrEditAccountAddressContainer';

export default AddOrEditAccountAddressContainer;